module.exports = __webpack_public_path__ + "img/ecobanka.ac5a887d.png";